export default "__VITE_ASSET__YxaY8KKZ__"